import { Fragment } from "react";
import TableCell from "@mui/material/TableCell";
import { TreeSupplies } from "../../../type/treeSupplies";
import i18n from "../../../i18n";
import { defaultLang, secondLang } from "../../../utils";

const TreeSuppliesTableItem: React.FC<{
  supplies: TreeSupplies;
}> = ({ supplies }) => {
  return (
    <Fragment>
      <TableCell align="left" width="500px">
        {i18n.language === secondLang
          ? supplies.species_name_transes?.[secondLang] === ""
            ? supplies.species_name_transes?.[defaultLang]
            : supplies.species_name_transes?.[secondLang]
          : supplies.species_name_transes?.[defaultLang]}
      </TableCell>
      <TableCell align="left" width="500px">
        {supplies.current_age}
      </TableCell>
      <TableCell align="left" width="200px">
        {supplies.available_trees}
      </TableCell>
    </Fragment>
  );
};

export default TreeSuppliesTableItem;
